export const photoSessionIdQueryName = 'job_id';
export const mountPhotoSessionIdQueryParam = (photoSessionId) => `?${photoSessionIdQueryName}=${photoSessionId}`;
export const getPhotoSessionIdFromQueryParam = () => new URLSearchParams(location.search).get(photoSessionIdQueryName);
